/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_CreateInputs */

const cs_settings_venues_create = /** @type {(inputs: Settings_Venues_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit pobočku`)
};

const en_settings_venues_create = /** @type {(inputs: Settings_Venues_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create office`)
};

/**
* | output |
* | --- |
* | "Create office" |
*
* @param {Settings_Venues_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_create = /** @type {((inputs?: Settings_Venues_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_create(inputs)
	return cs_settings_venues_create(inputs)
});